import styled from 'styled-components'
import {Link} from '@/src/shared/ui/link'

import theme, {media} from '@/src/config/theme'

export const Wrapper = styled.div``

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
`

export const PersonalFields = styled.div`
  ${GridWrapper} & {
    grid-column: 1 / 3;
    grid-row: 1 / 4;
  }
`

export const ContactFields = styled.div`
  ${GridWrapper} & {
    grid-column: 1 / 3;
    grid-row: 4 / 8;
  }

  margin-top: 20px;

  @media ${media.md} {
    margin-top: 38px;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  border: solid 1px ${theme.colors.borderColor};

  padding: 10px;

  @media ${media.md} {
    border: unset;
  }
`

export const FormTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
`

export const FormFields = styled.div`
  margin-top: 15px;
`

export const ShipmentForm = styled(Form)`
  margin-top: 15px;

  @media ${media.md} {
    padding-top: 35px;
  }
`

export const Checkbox = styled.input`
  padding-top: 15px;
`

export const Button = styled.input`
  margin-top: 15px;
  font-weight: 450;
  font-size: 1.25rem;
`

export const AgreeLink = styled(Link)`
    color: ${theme.colors.primary};
`